export const COLLABORATEURS = {
  lecture: { module: 'parametrage', element: 'collaborateurs', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'collaborateurs', rule: 'maj' },
  exporter: { module: 'parametrage', element: 'collaborateurs', rule: 'exporter' },
  supprimer: { module: 'parametrage', element: 'collaborateurs', rule: 'supprimer' },
};

export const SOCIETES = {
  lecture: { module: 'parametrage', element: 'societe/agence', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'societe/agence', rule: 'maj' },
  exporter: { module: 'parametrage', element: 'societe/agence', rule: 'exporter' },
  supprimer: { module: 'parametrage', element: 'societe/agence', rule: 'supprimer' },
};

export const ROLES = {
  lecture: { module: 'parametrage', element: 'roles', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'roles', rule: 'maj' },
  supprimer: { module: 'parametrage', element: 'roles', rule: 'supprimer' },
};

export const MODE_REGLEMENT = {
  lecture: { module: 'parametrage', element: 'mode_reglement', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'mode_reglement', rule: 'maj' },
  supprimer: { module: 'parametrage', element: 'mode_reglement', rule: 'supprimer' },
};

export const DELAI_REGLEMENT = {
  lecture: { module: 'parametrage', element: 'delai_reglement', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'delai_reglement', rule: 'maj' },
  supprimer: { module: 'parametrage', element: 'delai_reglement', rule: 'supprimer' },
};

export const TYPE_POINT_VENTE = {
  lecture: { module: 'parametrage', element: 'type_point_vente', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'type_point_vente', rule: 'maj' },
  supprimer: { module: 'parametrage', element: 'type_point_vente', rule: 'supprimer' },
};

export const PROFIL_TIERS = {
  lecture: { module: 'parametrage', element: 'profil_tiers', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'profil_tiers', rule: 'maj' },
  supprimer: { module: 'parametrage', element: 'profil_tiers', rule: 'supprimer' },
};

export const CIVILITE = {
  lecture: { module: 'parametrage', element: 'civilite', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'civilite', rule: 'maj' },
  supprimer: { module: 'parametrage', element: 'civilite', rule: 'supprimer' },
};

export const SECTEUR_ACTIVITE = {
  lecture: { module: 'parametrage', element: 'secteur_activite', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'secteur_activite', rule: 'maj' },
  supprimer: { module: 'parametrage', element: 'secteur_activite', rule: 'supprimer' },
};

export const SCHEMA_COMPTABLE = {
  lecture: { module: 'parametrage', element: 'schema_comptable', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'schema_comptable', rule: 'maj' },
  exporter: { module: 'parametrage', element: 'schema_comptable', rule: 'exporter' },
  supprimer: { module: 'parametrage', element: 'schema_comptable', rule: 'supprimer' },
};

export const EXERCICE_COMPTABLE = {
  lecture: { module: 'parametrage', element: 'exercice_comptable', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'exercice_comptable', rule: 'maj' },
  exporter: { module: 'parametrage', element: 'exercice_comptable', rule: 'exporter' },
  supprimer: { module: 'parametrage', element: 'exercice_comptable', rule: 'supprimer' },
};

export const DOMICILIATIONS_BANCAIRES = {
  lecture: { module: 'parametrage', element: 'domiciliation_bancaire', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'domiciliation_bancaire', rule: 'maj' },
  supprimer: { module: 'parametrage', element: 'domiciliation_bancaire', rule: 'supprimer' },
};

export const SUPPORT_COMMERCIAL = {
  lecture: { module: 'parametrage', element: 'support_commercial', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'support_commercial', rule: 'maj' },
  supprimer: { module: 'parametrage', element: 'support_commercial', rule: 'supprimer' },
  exporter: { module: 'parametrage', element: 'support_commercial', rule: 'exporter' },
};

export const COMMENTAIRE = {
  lecture: { module: 'parametrage', element: 'commentaire', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'commentaire', rule: 'maj' },
  supprimer: { module: 'parametrage', element: 'commentaire', rule: 'supprimer' },
  exporter: { module: 'parametrage', element: 'commentaire', rule: 'exporter' },
};

export const PARAMETRAGE_EDITION = {
  lecture: { module: 'parametrage', element: 'edition', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'edition', rule: 'maj' },
  supprimer: { module: 'parametrage', element: 'edition', rule: 'supprimer' },
  exporter: { module: 'parametrage', element: 'edition', rule: 'exporter' },
};

export const PARAMETRAGE_REGIME_TVA = {
  lecture: { module: 'parametrage', element: 'regime_tva', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'regime_tva', rule: 'maj' },
  supprimer: { module: 'parametrage', element: 'regime_tva', rule: 'supprimer' },
  exporter: { module: 'parametrage', element: 'regime_tva', rule: 'exporter' },
};

export const FACE_MOTIF_NON_COM = {
  lecture: { module: 'parametrage', element: 'face_motif_non_com', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'face_motif_non_com', rule: 'maj' },
  supprimer: { module: 'parametrage', element: 'face_motif_non_com', rule: 'supprimer' },
};

export const GENERAL = {
  lecture: { module: 'parametrage', element: 'general', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'general', rule: 'maj' },
};

export const COMPTE_ANALYTIQUE = {
  lecture: { module: 'parametrage', element: 'compte_analytique', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'compte_analytique', rule: 'maj' },
  exporter: { module: 'parametrage', element: 'compte_analytique', rule: 'exporter' },
  supprimer: { module: 'parametrage', element: 'compte_analytique', rule: 'supprimer' },
};

export const CATEGORIE_GROUPE_PRODUIT_DEDUCTIBLE = {
  lecture: { module: 'parametrage', element: 'categorie_groupe_produit_deductible', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'categorie_groupe_produit_deductible', rule: 'maj' },
  exporter: { module: 'parametrage', element: 'categorie_groupe_produit_deductible', rule: 'exporter' },
  supprimer: { module: 'parametrage', element: 'categorie_groupe_produit_deductible', rule: 'supprimer' },
};

export const LIBELLE_REMISE = {
  lecture: { module: 'parametrage', element: 'libelle_remise', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'libelle_remise', rule: 'maj' },
  supprimer: { module: 'parametrage', element: 'libelle_remise', rule: 'supprimer' },
  exporter: { module: 'parametrage', element: 'libelle_remise', rule: 'exporter' },
};

export const INDEXATION = {
  lecture: { module: 'parametrage', element: 'indexation', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'indexation', rule: 'maj' },
  supprimer: { module: 'parametrage', element: 'indexation', rule: 'supprimer' },
  exporter: { module: 'parametrage', element: 'indexation', rule: 'exporter' },
};

export const TYPE_CONTACT = {
  lecture: { module: 'parametrage', element: 'type_contact', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'type_contact', rule: 'maj' },
  supprimer: { module: 'parametrage', element: 'type_contact', rule: 'supprimer' },
  exporter: { module: 'parametrage', element: 'type_contact', rule: 'exporter' },
};

export const MOTIF_ANNULATION_REGLEMENT = {
  lecture: { module: 'parametrage', element: 'motif_annulation_reglement', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'motif_annulation_reglement', rule: 'maj' },
  exporter: { module: 'parametrage', element: 'motif_annulation_reglement', rule: 'exporter' },
  supprimer: { module: 'parametrage', element: 'motif_annulation_reglement', rule: 'supprimer' },
};

export const SIGNATURE_ELECTRONIQUE = {
  lecture: { module: 'parametrage', element: 'signature_electronique', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'signature_electronique', rule: 'maj' },
  exporter: { module: 'parametrage', element: 'signature_electronique', rule: 'exporter' },
};

export const MARQUE = {
  lecture: { module: 'parametrage', element: 'marque', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'marque', rule: 'maj' },
  supprimer: { module: 'parametrage', element: 'marque', rule: 'supprimer' },
};

export const TAG = {
  lecture: { module: 'parametrage', element: 'tag', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'tag', rule: 'maj' },
  exporter: { module: 'parametrage', element: 'tag', rule: 'exporter' },
  supprimer: { module: 'parametrage', element: 'tag', rule: 'supprimer' },
};

export const NOMENCLATURE_TYPE = {
  lecture: { module: 'parametrage', element: 'nomenclature_type', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'nomenclature_type', rule: 'maj' },
  exporter: { module: 'parametrage', element: 'nomenclature_type', rule: 'exporter' },
  supprimer: { module: 'parametrage', element: 'nomenclature_type', rule: 'supprimer' },
};

export const SECTEUR = {
  lecture: { module: 'parametrage', element: 'secteur', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'secteur', rule: 'maj' },
  exporter: { module: 'parametrage', element: 'secteur', rule: 'exporter' },
  supprimer: { module: 'parametrage', element: 'secteur', rule: 'supprimer' },
};

export const PAYS = {
  lecture: { module: 'parametrage', element: 'pays', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'pays', rule: 'maj' },
  exporter: { module: 'parametrage', element: 'pays', rule: 'exporter' },
  supprimer: { module: 'parametrage', element: 'pays', rule: 'supprimer' },
};

export const FONCTION_CONTACT = {
  lecture: { module: 'parametrage', element: 'fonction_contact', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'fonction_contact', rule: 'maj' },
  exporter: { module: 'parametrage', element: 'fonction_contact', rule: 'exporter' },
  supprimer: { module: 'parametrage', element: 'fonction_contact', rule: 'supprimer' },
};

export const SPRINT = {
  lecture: { module: 'parametrage', element: 'sprint', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'sprint', rule: 'maj' },
  supprimer: { module: 'parametrage', element: 'sprint', rule: 'supprimer' },
};

export const NATURE_SUPPORT_AFFICHE = {
  lecture: { module: 'parametrage', element: 'nature_support_affiche', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'nature_support_affiche', rule: 'maj' },
  exporter: { module: 'parametrage', element: 'nature_support_affiche', rule: 'exporter' },
  supprimer: { module: 'parametrage', element: 'nature_support_affiche', rule: 'supprimer' },
};

export const COMPETENCE_FOURNISSEUR = {
  lecture: { module: 'parametrage', element: 'competence_fournisseur', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'competence_fournisseur', rule: 'maj' },
  exporter: { module: 'parametrage', element: 'competence_fournisseur', rule: 'exporter' },
  supprimer: { module: 'parametrage', element: 'competence_fournisseur', rule: 'supprimer' },
};

export const SERVICE = {
  lecture: { module: 'parametrage', element: 'service', rule: 'lecture' },
  maj: { module: 'parametrage', element: 'service', rule: 'maj' },
  exporter: { module: 'parametrage', element: 'service', rule: 'exporter' },
  supprimer: { module: 'parametrage', element: 'service', rule: 'supprimer' },
};
